import { render } from "./PreviewDraft.vue?vue&type=template&id=2872a9b4"
import script from "./script/index?vue&type=script&lang=js&external"
export * from "./script/index?vue&type=script&lang=js&external"

import "./PreviewDraft.vue?vue&type=style&index=0&id=2872a9b4&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__